import classNames from "classnames";

import type { BriefingReportPageData } from "content-ui/briefings/fetchers/briefingReportFetcher";

import Heading from "content-ui/briefings/components/briefingsReports/elements/heading";
import CardContainer from "content-ui/briefings/components/briefingsReports/elements/cardContainer";
import { LazyIframe } from "components/lazyIframe/lazyIframe";

const StatsCard = ({
  briefing,
  id,
}: {
  briefing: BriefingReportPageData;
  id: string;
}) => {
  const renderChart = (
    flourishId: string,
    isSingle: boolean,
    index: number
  ) => {
    return (
      <div
        key={index}
        className={classNames("mb-6 w-100 md:mb-0", {
          "md:max-w-[46%]": !isSingle,
        })}
      >
        <LazyIframe
          title="Interactive or visual content"
          src={`https://flo.uri.sh/visualisation/${flourishId}/embed`}
          className="flourish-embed-iframe"
          frameBorder="0"
          scrolling="no"
          style={{ width: "100%", height: "600px" }}
        ></LazyIframe>
      </div>
    );
  };

  // Filter out entries with empty flourishId strings
  const charts = briefing.flourishIds.filter((chart) => chart.flourishId);

  return (
    <CardContainer
      id={`content__${id}`}
      innerClassNames={"grid md:gap-[16px] gap-[0px]"}
    >
      <Heading text={briefing.keyStatsHeading} id={id} />
      <div className="mb-2 flex flex-col items-center gap-[8px] text-center md:grid-cols-3 md:flex-row md:justify-between">
        {briefing.keyStats.map((stat, i) => (
          <div
            key={i}
            className="flex h-full w-100 flex-col justify-start self-center bg-[#f8f7f9] px-[4px] pt-[36px] pb-[44px] text-[#002EA5] md:max-w-[260px] md:px-[8px]"
          >
            <p className="text-[42px] font-[700] md:text-[48px]">
              {stat.figure}
            </p>
            <p className="text-[16px] font-[700] text-[#1B2325]">
              {stat.description}
              <sup>{stat.referenceNumber}</sup>
            </p>
          </div>
        ))}
      </div>

      {/* Dynamically wrap charts in responsive divs */}
      {charts.map((el, i) => {
        let chartRow: { flourishId: string }[] = [];
        let isSingle = true;

        if (i < 2) {
          chartRow.push(el);
        } else if (i % 2 !== 0) {
          return null;
        } else {
          chartRow = [charts[i], charts[i + 1]].filter((el) => el);
          isSingle = chartRow.length !== 2;
        }

        return (
          <div
            key={i}
            className="flex flex-col items-center justify-between md:flex-row"
          >
            {chartRow.map(({ flourishId }, index) =>
              renderChart(flourishId, isSingle, index)
            )}
          </div>
        );
      })}
    </CardContainer>
  );
};

export default StatsCard;
